import { createContext } from "react";

import { LanguageContextState } from "./types";

const LanguageContext = createContext({} as LanguageContextState);

export default LanguageContext;
